/**
 * The tour of a deal-screening workflow's Deals tab (DOP-625), on the KPI
 * dashboard's spotlight (`Tour/SpotlightTour`). Runs once per person, the
 * first time the Deals tab is opened; "Take the tour" replays it.
 */

import React from "react";
import SpotlightTour, { type TourStep } from "../Tour/SpotlightTour";

const STEPS: readonly TourStep[] = [
	{
		anchor: '[data-tour="screen-deal"]',
		title: "Start with a deal folder",
		body: "Screen a deal picks a folder from the Deal Room. Doppler reads its files and writes a first-look memo.",
		next: "Next: where deals stand",
	},
	{
		anchor: '[data-tour="deal-tiles"]',
		title: "Your deals at a glance",
		body: "How many deals have gaps open, how many are all clear, and how many are still being written.",
		next: "Next: your deals",
	},
	{
		anchor: '[data-testid="deals-table"]',
		title: "One row per deal",
		body: "Each deal shows its status and one button. Open a memo to read it: every sentence links to the page it came from.",
		next: "Next: the gaps",
	},
	{
		anchor: '[data-tab-id="review"]',
		title: "Open items land in Gaps",
		body: "Figures that disagree between files, and facts the memo couldn't find, for every deal in one list.",
		next: "Next: the memo outline",
	},
	{
		anchor: '[data-tab-id="settings"]',
		title: "Shape every memo",
		body: "The sections every memo follows. Change them here and the next memo uses them.",
		next: "Got it",
	},
];

const DealScreeningTour: React.FC<{ onClose: () => void }> = ({ onClose }) => (
	<SpotlightTour steps={STEPS} onClose={onClose} testId="deal-screening-tour-backdrop" />
);

export default DealScreeningTour;
